import dayjs from 'dayjs'

import {
  CHART_REVIEW_EXPORT_PDF_GET,
  DATE_TIME_FORMAT_FOR_SERVER
} from 'src/constants'
import { exportReport } from 'src/utils/Functions'

export const exportChartReviewPdf = async (chartReviewUuid = '', query = {}) => {
  if (!chartReviewUuid) return false

  return exportReport(
    {
      pathname: CHART_REVIEW_EXPORT_PDF_GET,
      params: { chartReviewUuid },
      query
    },
    `chart_review_${dayjs().format(DATE_TIME_FORMAT_FOR_SERVER)}.pdf`
  )
}
